import { render } from "./GooglePayTab.vue?vue&type=template&id=4648d64d"
import script from "./GooglePayTab.vue?vue&type=script&setup=true&lang=js"
export * from "./GooglePayTab.vue?vue&type=script&setup=true&lang=js"

import "./GooglePayTab.vue?vue&type=style&index=0&id=4648d64d&lang=scss"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/modules/billing/components/inapp/GooglePayTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4648d64d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4648d64d', __exports__)) {
    console.log('reload')
    api.reload('4648d64d', __exports__)
  }
  
  module.hot.accept("./GooglePayTab.vue?vue&type=template&id=4648d64d", () => {
    console.log('re-render')
    api.rerender('4648d64d', render)
  })

}


export default __exports__